export default __webpack_public_path__ + "static/Signature Class – Horizontal 800x400-63d21b60b7315174befdf9e88e4e7fdc.svg";